module.exports = __webpack_public_path__ + "img/flower_leaf_23.70b44d35.png";